export const c_label__text_MaxWidth = {
  "name": "--pf-v5-c-label__text--MaxWidth",
  "value": "100%",
  "var": "var(--pf-v5-c-label__text--MaxWidth)"
};
export default c_label__text_MaxWidth;